import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useToast } from '../../hooks/useToast';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles?: string[]; // Nuevo prop opcional
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
    const token = localStorage.getItem('authToken');
    const userRole = localStorage.getItem('userRole') || ''; // Obtenemos el rol
    const location = useLocation();
    // No podemos usar el hook useToast directamente en el render para efectos secundarios,
    // pero la redirección es suficiente feedback visual.

    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Si la ruta exige roles y el usuario no lo tiene
    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // Redirigir al dashboard (o a una página de "No Autorizado")
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;